import { Color, SkeletonBox, Spacing, Text } from '@billy/design-system'
import type { ColorToken } from '@shinetools/lumen-tokens/web/colors'
import React, { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface WidgetProps {
  autoHeight?: boolean
  backgroundColor?: Color | ColorToken
  children: ReactNode
  className?: string
  isHighlighted?: boolean
  isLoading?: boolean
  sideActions?: ReactNode
  subtitle?: ReactNode
  title?: ReactNode
}
export const Widget = ({
  autoHeight,
  backgroundColor = Color.White,
  children,
  className,
  isHighlighted,
  isLoading = false,
  sideActions,
  title,
  subtitle,
}: WidgetProps): ReactElement => (
  <Styled.WidgetWrapper
    className={className}
    highlighted={isHighlighted}
    isLoading={isLoading}
    autoHeight={autoHeight}
    backgroundColor={backgroundColor}
  >
    {isLoading ? (
      <SkeletonBox fullWidth fullHeight />
    ) : (
      <>
        {(title || subtitle || sideActions) && (
          <Styled.Header>
            {(title || subtitle) && (
              <Styled.TitleComponentsGroup spacing={Spacing.S8} centered={false}>
                {title && (
                  <Text variant="h4" truncate>
                    {title}
                  </Text>
                )}
                {subtitle && (
                  <Text colorVariant="secondary" variant="bodySM">
                    {subtitle}
                  </Text>
                )}
              </Styled.TitleComponentsGroup>
            )}
            {sideActions && <Styled.SideActions>{sideActions}</Styled.SideActions>}
          </Styled.Header>
        )}
        {children}
      </>
    )}
  </Styled.WidgetWrapper>
)
